(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review_slider"] && !Shopify.designMode) return;
  try {
    
  var buttons = document.querySelectorAll(".top_review_count");
  console.log(buttons);
  buttons.forEach(function(button) {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      console.log("You clicked a review top");
      if(document.querySelector('.review__slider') != null){
        document.querySelector('.review__slider').scrollIntoView({
            behavior: 'smooth'
        });  
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll_buttons"] && !Shopify.designMode) return;
  try {
    
  var buttons = document.querySelectorAll(".single_btn a");
  console.log(buttons);
  buttons.forEach(function(button) {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      console.log("You clicked a button");
      var div_id = button.getAttribute('href');
      if(document.querySelector(div_id) != null){
        document.querySelector(div_id).scrollIntoView({
            behavior: 'smooth'
        });  
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
